// actionTypes.js
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_LOADING = "SET_LOADING";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
